import { any, func, oneOfType, shape } from "prop-types";

/**
 * Going with the most flexible approach for the time being
 *
 * More info on how this solution was arrived at
 * https://stackoverflow.com/questions/48007326/what-is-the-correct-proptype-for-a-ref-in-react
 */
/** @deprecated use TypeScript interface or type instead */
export const refType = oneOfType([
  func,
  shape({
    current: any,
  }),
]);
